import { render } from "./topBanner.vue?vue&type=template&id=2c7e0769"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Websites\\Green Earth Marine Project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__